import { useRequiredContext } from "@redotech/react-util/context";
import CodeFilledIcon from "@redotech/redo-icons/code-02_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import { useMatch } from "react-router-dom";

export const DevItems = memo(function DevItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const user = useContext(UserContext);
  const isRedoUser =
    (user?.email && user.email.endsWith("@getredo.com")) || false;

  const devBaseUrl = routes.supportBaseUrl + "/dev";
  const anyChildSelected = useMatch(`${devBaseUrl}/*`);

  // Only show dev navigation for Redo users
  if (!isRedoUser) {
    return null;
  }

  const children = [
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getSupportDevSubRoute("conversation-insights"),
      }}
      friendlyName="Conversation Insights"
      id="dev-conversation-insights"
      key="dev-conversation-insights"
    />,
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getSupportDevSubRoute("editor-testing"),
      }}
      friendlyName="Faq Editor Testing"
      id="dev-editor-testing"
      key="dev-editor-testing"
    />,
  ];

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: devBaseUrl }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={CodeFilledIcon}
      friendlyName="Dev"
      id="dev"
      UnfilledIcon={CodeFilledIcon}
    >
      {children}
    </RedoSecondaryNavItem>
  );
});
